<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
    :disabled="readonly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="label"
        style="font-size: 14px"
        hide-details="auto"
        dense
        outlined
        prepend-inner-icon="mdi-clock"
        v-bind="attrs"
        v-on="on"
        :readonly="readonly"
        :value="computedTimeRangeText"
      ></v-text-field>
    </template>
    <!-- <v-date-picker v-model="valueProxy" @input="showMenu = false" />
    <v-time-picker
      v-if="showMenu"
      v-model="time"
      full-width
      @click:minute="$refs.menu.save(time)"
    ></v-time-picker> -->
    <v-card>
      <v-container>
        <v-row justify="space-around" align="center">
          <v-col>
            <h2>Start:</h2>
            <v-time-picker
              :format="format"
              v-model="start"
              :max="end"
              :min="min"
              :allowedMinutes="allowedMinutes"
            ></v-time-picker>
          </v-col>
          <v-col>
            <h2>End:</h2>
            <v-time-picker
              :format="format"
              v-model="end"
              :min="start"
              :max="max"
              :allowedMinutes="allowedMinutes"
            ></v-time-picker>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import { timeRange, timeDuration } from '@/services/filters';
import moment from 'moment';
export default {
  props: {
    startDateTime: {
      type: [Date, String],
      default: null,
    },
    endDateTime: {
      type: [Date, String],
      default: null,
    },
    min: {
      type: [Date, String],
      default: null,
    },
    max: {
      type: [Date, String],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: '24hr',
    },
    minutePerSlot: {
      type: Number,
      default: 15,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      start: null,
      end: null,
      showMenu: false,
    };
  },
  computed: {
    computedTimeRangeText() {
      const startDateTime = moment(this.start, 'HH:mm').toDate();
      const endDateTime = moment(this.end, 'HH:mm').toDate();
      // //duration
      // const duration = moment.duration(moment(endDateTime).diff(startDateTime));
      // // duration in hours
      // const hours = parseInt(duration.asHours());
      // // duration in minutes
      // const minutes = parseInt(duration.asMinutes()) % 60;

      const timeRangeText = `${this.timeRange({ start: startDateTime, end: endDateTime })}`;
      const durationText = `${this.timeDuration({ start: startDateTime, end: endDateTime })}`;
      return timeRangeText + (durationText ? ` (${durationText})` : '');
      // if (hours || minutes) {
      //   const durationText = (hours ? `${hours}h` : '') + (minutes ? `${minutes}m` : '');
      //   result += ` (${durationText})`;
      // }
      // return result || this.placeHolder;
    },
  },
  watch: {
    startDateTime: {
      handler(newValue) {
        if (newValue) {
          this.start = moment(newValue).format('HH:mm');
        }
      },
      immediate: true,
    },
    endDateTime: {
      handler(newValue) {
        if (newValue) {
          this.end = moment(newValue).format('HH:mm');
        }
      },
      immediate: true,
    },
    start(newValue) {
      const date = this.startDateTime ? moment(this.startDateTime) : moment();
      const time =
        this.min && moment(this.min, 'HH:mm') > moment(newValue, 'HH:mm')
          ? moment(this.min, 'HH:mm')
          : moment(newValue, 'HH:mm');
      date.set({
        hour: time.get('hour'),
        minute: time.get('minute'),
        second: time.get('second'),
      });
      this.$emit('update:startDateTime', date.toDate());
    },
    end(newValue) {
      const date = this.endDateTime ? moment(this.endDateTime) : moment();
      const time =
        this.max && moment(this.max, 'HH:mm') < moment(newValue, 'HH:mm')
          ? moment(this.max, 'HH:mm')
          : moment(newValue, 'HH:mm');
      date.set({
        hour: time.get('hour'),
        minute: time.get('minute'),
        second: time.get('second'),
      });
      this.$emit('update:endDateTime', date.toDate());
    },
  },
  methods: {
    timeRange,
    timeDuration,
    allowedMinutes(m) {
      return m % this.minutePerSlot === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field input {
  padding: 5px 0;
}
</style>
